/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Autocomplete,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
import moment from 'moment';
import useProductSamplingInventoryContext from '../context/useProductSamplingInventoryContext';

export default function AddProductModal() {
  const {
    addProductModal,
    setAddProductModal,
    productOptions,
    specialtyOptions,
    handleAddProduct,
  } = useContext(useProductSamplingInventoryContext);

  const handleAddRow = () => {
    setAddProductModal({
      ...addProductModal,
      products: [
        ...addProductModal.products,
        {
          id: addProductModal.products.length + 1,
          product_code: '',
          product_name: '',
          specialty: '',
          qty: 0,
          product_selected: { value: null, label: 'Select Product' },
          specialty_selected: { value: null, label: 'Select Specialty' },
        },
      ],
    });
  };

  const handleRemoveRow = (row) => {
    const newArr = addProductModal?.products?.filter((item) => row.id !== item.id);

    setAddProductModal({
      ...addProductModal,
      products: newArr,
    });
  };

  const handleChangeDropdown = (newValue, row, index, name) => {
    const newArr = [...addProductModal.products];

    if (name === 'product') {
      newArr[index] = {
        id: row.id,
        product_code: newValue?.value,
        product_name: newValue?.label,
        specialty: newArr[index]?.specialty,
        qty: newArr[index]?.qty,
        product_selected: newValue,
        specialty_selected: newArr[index]?.specialty_selected,
      };
    }

    if (name === 'specialty') {
      newArr[index] = {
        id: row.id,
        product_code: newArr[index]?.product_code,
        product_name: newArr[index]?.product_name,
        specialty: newValue?.value,
        qty: newArr[index]?.qty,
        product_selected: newArr[index]?.product_selected,
        specialty_selected: newValue,
      };
    }

    if (name === 'quantity') {
      newArr[index] = {
        id: row.id,
        product_code: newArr[index]?.product_code,
        product_name: newArr[index]?.product_name,
        specialty: newArr[index]?.specialty,
        qty: newValue.target.value,
        product_selected: newArr[index]?.product_selected,
        specialty_selected: newArr[index]?.specialty_selected,
      };
    }

    setAddProductModal({ ...addProductModal, products: newArr });
  };

  const columns = [
    {
      field: 'specialty_selected',
      headerName: 'MD Specialty',
      width: 300,
      renderCell: (params) => (
        <div>
          <Autocomplete
            disablePortal
            id='specialty_selected'
            disableClearable
            options={specialtyOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => <TextField {...param} />}
            value={params?.row?.specialty_selected}
            onChange={(e, newValue) =>
              handleChangeDropdown(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
                'specialty',
              )
            }
            sx={{ backgroundColor: '#fff', width: '345%' }}
            required
          />
        </div>
      ),
    },
    {
      field: 'product_selected',
      headerName: 'Product Name',
      width: 300,
      renderCell: (params) => (
        <div>
          <Autocomplete
            disablePortal
            id='product_selected'
            disableClearable
            options={productOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => <TextField {...param} />}
            value={params?.row?.product_selected}
            onChange={(e, newValue) =>
              handleChangeDropdown(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
                'product',
              )
            }
            sx={{ backgroundColor: '#fff', width: '345%' }}
            required
          />
        </div>
      ),
    },
    {
      field: 'qty',
      headerName: 'Quantity',
      width: 300,
      renderCell: (params) => (
        <div>
          <TextField
            id='filled-number'
            type='number'
            value={params?.row?.qty}
            sx={{
              backgroundColor: '#fff',
              width: '140%',
              'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              'input[type=number]': {
                MozAppearance: 'textfield',
              },
            }}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            onChange={(e, newValue) =>
              handleChangeDropdown(e, params.row, params.api.getRowIndex(params.row.id), 'quantity')
            }
          />
        </div>
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      alignitems: 'center',
      renderCell: ({ row }) => (
        <div>
          <Button
            size='small'
            variant='contained'
            color='error'
            startIcon={<CloseIcon />}
            onClick={() => handleRemoveRow(row)}
          >
            {' '}
            Remove
          </Button>
        </div>
      ),
    },
  ];
  const handleClose = () => {
    setAddProductModal({ ...addProductModal, toggle: false, product: {} });
  };

  const handleChangeDate = (value) => {
    setAddProductModal({ ...addProductModal, date: moment(value).format('YYYY-MM') });
  };
  return (
    <Dialog onClose={handleClose} open={addProductModal.toggle} fullWidth maxWidth='lg'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Add Product
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid xs={3} sm={3} md={3}>
            <DatePicker
              label='date'
              views={['month', 'year']}
              value={addProductModal?.date}
              // eslint-disable-next-line react/jsx-props-no-spreading
              /* eslint-disable react/jsx-props-no-spreading */
              renderInput={(params) => (
                <TextField {...params} label='Date' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeDate(value)}
            />
          </Grid>
          <Grid xs={9} sm={9} md={9}>
            <Button
              size='small'
              variant='contained'
              color='success'
              sx={{ float: 'right' }}
              onClick={(e) => handleAddRow()}
              startIcon={<AddOutlinedIcon />}
            >
              Add New Row(s)
            </Button>
          </Grid>
        </Grid>

        <Grid xs={12} sm={12} md={12}>
          <div className='table-container' style={{ height: '500px', marginTop: '20px' }}>
            <DataGridPro
              rows={addProductModal?.products}
              columns={columns}
              getRowHeight={() => 'auto'}
              sx={{
                '& .MuiDataGrid-cell': {
                  padding: 0,
                },
              }}
            />
          </div>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='success' onClick={handleAddProduct}>
          Submit
        </Button>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
